import classnames from 'classnames'
import type { FunctionComponent } from 'react'
import React, { Children, cloneElement, isValidElement } from 'react'

import styles from './Row.module.scss'

export const Row: FunctionComponent<Props> = ({ children, className }) => (
  <tr className={classnames(styles.container, className)}>
    {Children.toArray(children).map((Child, index) =>
      isValidElement(Child) ? cloneElement(Child as React.ReactElement, { index }) : null
    )}
  </tr>
)

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Child node to be rendered
   */
  children: React.ReactNode
  /**
   * Classname to be added
   */
  className?: string
}
